import React from 'react';
import {Helmet} from "react-helmet";

function AppHelmet(props) {
    return (
      <div>
        <Helmet>
            <meta charSet="utf-8" content="Connecting Italian Producers and Wholesalers worldwide" />
            <title>{props.title}</title>
            {/* <link rel="shortcut icon" href='../../assets/images/agrico.ico'/> */}
        </Helmet>
      </div>
    );
}

export default AppHelmet
